(function () {
  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function num(v, fallback) {
    var n = parseFloat(String(v || "").replace(",", "."), 10);
    return isFinite(n) ? n : fallback;
  }

  function euro(n) {
    return n.toLocaleString("nl-NL", { style: "currency", currency: "EUR" });
  }

  function ufFetch(url, opts) {
    if (window.UF_OFFLINE && typeof window.UF_OFFLINE.fetch === "function") {
      return window.UF_OFFLINE.fetch(url, opts);
    }
    return fetch(url, opts);
  }

  function contactLine() {
    if (window.UF_OFFLINE && typeof window.UF_OFFLINE.contactLine === "function") {
      return window.UF_OFFLINE.contactLine();
    }
    return "Mail info@urbanfloors.nl of bel 085-0603648.";
  }

  function offerteMailBody(data) {
    data = data || {};
    return [
      "Offerte-aanvraag (dashboard offline)",
      "Naam: " + (data.customerName || ""),
      "E-mail: " + (data.customerEmail || ""),
      "Telefoon: " + (data.customerPhone || ""),
      "Adres: " + (data.customerAddress || ""),
      "Postcode: " + (data.customerZip || ""),
      "Plaats: " + (data.customerCity || ""),
      "Product: " + (data.handle || ""),
      "m²: " + (data.areaM2 || ""),
      "Snijverlies: " + (data.wastePct || "") + "%",
      "Kortingen: " + ((data.discountCodes || []).join(", ") || "geen"),
      "Pagina: " + (location.href || ""),
    ].join("\n");
  }

  function postCart(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body || {}),
    }).then(function (res) {
      if (!res.ok) throw new Error("cart failed");
      return res.json();
    });
  }

  function applyOfferteCart(opts) {
    var variantId = parseInt(String(opts.variantId || ""), 10);
    var qty = parseInt(String(opts.packQty || ""), 10);
    var code = String(opts.discount || "").trim();
    var fallback = String(opts.fallbackUrl || "").trim();
    if (!variantId || !qty || qty < 1) {
      if (fallback) window.location.href = fallback;
      return Promise.resolve();
    }
    return postCart("/cart/clear.js")
      .then(function () {
        return postCart("/cart/add.js", {
          items: [{ id: variantId, quantity: qty }],
        });
      })
      .then(function () {
        try {
          sessionStorage.setItem("uf_cart_discount_manual", "1");
          if (code) sessionStorage.setItem("uf_offerte_discount_code", code);
        } catch (err) {
          /* ignore */
        }
        if (code) {
          window.location.href =
            "/discount/" +
            encodeURIComponent(code) +
            "?redirect=" +
            encodeURIComponent("/cart");
          return;
        }
        window.location.href = "/cart";
      })
      .catch(function () {
        if (fallback) window.location.href = fallback;
      });
  }

  function init(root) {
    var modal = qs(root, "[data-uf-offerte-modal]");
    if (!modal) return;

    var openBtns = Array.prototype.slice.call(root.querySelectorAll("[data-uf-offerte-open]"));
    var productRoot = root.closest(".uf-lf-product");
    if (productRoot) {
      productRoot.querySelectorAll("[data-uf-offerte-open]").forEach(function (btn) {
        if (openBtns.indexOf(btn) === -1) openBtns.push(btn);
      });
    }
    if (!openBtns.length) return;

    var slides = Array.prototype.slice.call(modal.querySelectorAll("[data-uf-offerte-slide]"));
    var dots = Array.prototype.slice.call(modal.querySelectorAll("[data-uf-offerte-dot]"));
    var steps = Array.prototype.slice.call(modal.querySelectorAll("[data-uf-offerte-step]"));
    var backBtn = qs(modal, "[data-uf-offerte-back]");
    var nextBtn = qs(modal, "[data-uf-offerte-next]");
    var errorEl = qs(modal, "[data-uf-offerte-error]");
    var summaryEl = qs(modal, "[data-uf-offerte-summary]");
    var printLink = qs(modal, "[data-uf-offerte-print]");
    var cartLink = qs(modal, "[data-uf-offerte-cart]");
    var stackEl = qs(modal, "[data-uf-offerte-stack]");
    var addBtn = qs(modal, "[data-uf-offerte-add-code]");
    var extraInput = qs(modal, "[name='extraDiscountCode']");
    var statusEl = qs(modal, "[data-uf-offerte-code-status]");
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    var step = 0;
    var busy = false;
    var looking = false;
    var result = null;
    var stacked = [];

    function apiBase() {
      return (root.getAttribute("data-api") || "").replace(/\/$/, "");
    }

    function defaultPromo() {
      return (root.getAttribute("data-promo-active") || "").trim();
    }

    function selectedPromo() {
      var active = qs(modal, "[data-promo].is-active");
      if (active) return (active.getAttribute("data-promo") || "").trim();
      return defaultPromo();
    }

    function promoPctFor(code) {
      var active = qs(modal, "[data-promo].is-active");
      if (active && (active.getAttribute("data-promo") || "").trim() === code) {
        var fromBtn = Number(active.getAttribute("data-promo-pct") || 0);
        if (fromBtn > 0) return fromBtn;
      }
      if (window.UF_LF_ACTIE && typeof window.UF_LF_ACTIE.getPctForName === "function") {
        var fromCal = window.UF_LF_ACTIE.getPctForName(code);
        if (fromCal > 0) return fromCal;
      }
      return 5;
    }

    function keepGeneralPromo() {
      var promo = selectedPromo();
      stacked = stacked.filter(function (item) {
        return !item.general;
      });
      if (!promo || hasCode(promo)) {
        renderStack();
        return;
      }
      var pct = promoPctFor(promo);
      stacked.unshift({
        code: promo,
        title: promo,
        summary: promo + " (−" + pct + "%)",
        kind: "percent",
        percent: pct,
        general: true,
      });
      renderStack();
    }

    function setStep(n) {
      step = Math.max(0, Math.min(slides.length - 1, n));
      slides.forEach(function (slide, i) {
        slide.classList.toggle("is-active", i === step);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === step);
      });
      steps.forEach(function (item, i) {
        item.classList.toggle("is-active", i === step);
        item.classList.toggle("is-done", i < step);
      });
      if (backBtn) backBtn.hidden = step === 0 || step === 4;
      if (nextBtn) {
        nextBtn.hidden = step === 4;
        nextBtn.textContent = step === 3 ? "Offerte maken" : "Volgende";
      }
      if (errorEl) errorEl.textContent = "";
      if (step === 2) ensureDefaultPromo();
      if (window.ufTrack) window.ufTrack("offerte_step", { step: step });
    }

    function renderStack() {
      if (!stackEl) return;
      if (!stacked.length) {
        stackEl.innerHTML = "";
        return;
      }
      stackEl.innerHTML = stacked
        .map(function (item) {
          return (
            '<div class="uf-offerte-modal__chip" data-code="' +
            escapeAttr(item.code) +
            '"><span><strong>' +
            escapeHtml(item.title || item.code) +
            "</strong><small>" +
            escapeHtml(item.summary || item.code) +
            '</small></span><button type="button" class="uf-offerte-modal__chip-remove" data-remove-code="' +
            escapeAttr(item.code) +
            '">Weg</button></div>'
          );
        })
        .join("");
    }

    function hasCode(code) {
      var key = String(code || "").trim().toLowerCase();
      return stacked.some(function (item) {
        return item.code.toLowerCase() === key;
      });
    }

    function removeCode(code) {
      var key = String(code || "").trim().toLowerCase();
      stacked = stacked.filter(function (item) {
        return item.code.toLowerCase() !== key;
      });
      if (defaultPromo() && key === defaultPromo().toLowerCase()) {
        modal.querySelectorAll("[data-promo]").forEach(function (el) {
          el.classList.toggle("is-active", (el.getAttribute("data-promo") || "") === "");
        });
      }
      renderStack();
    }

    function lookupCode(code) {
      var api = apiBase();
      if (!api) return Promise.reject(new Error("Offerte-API ontbreekt."));
      return ufFetch(api + "/api/offertes?code=" + encodeURIComponent(code))
        .then(function (res) {
          return res.text().then(function (text) {
            var body = {};
            if (text) {
              try {
                body = JSON.parse(text);
              } catch (err) {
                throw new Error("Ongeldig antwoord van de server.");
              }
            }
            if (!res.ok) throw new Error(body.error || "Code niet gevonden");
            return body.discount;
          });
        })
        .catch(function (err) {
          var msg = err && err.message ? err.message : "Code controleren mislukt.";
          if (/failed to fetch|networkerror|load failed/i.test(msg)) {
            throw new Error("Kon de offerte-server niet bereiken. Probeer het opnieuw.");
          }
          throw err;
        });
    }

    function setCodeStatus(kind, text) {
      if (!statusEl) return;
      if (!text) {
        statusEl.hidden = true;
        statusEl.textContent = "";
        statusEl.classList.remove("is-ok", "is-bad");
        return;
      }
      statusEl.hidden = false;
      statusEl.textContent = text;
      statusEl.classList.toggle("is-ok", kind === "ok");
      statusEl.classList.toggle("is-bad", kind === "bad");
    }

    function addCode(code, opts) {
      var clean = String(code || "").trim();
      var options = opts || {};
      if (!clean) {
        if (!options.silent) setCodeStatus("bad", "Vul eerst een code in.");
        return Promise.resolve(false);
      }
      if (hasCode(clean)) {
        if (extraInput) extraInput.value = "";
        setCodeStatus("ok", "Deze code staat al in de stapel.");
        return Promise.resolve(true);
      }
      looking = true;
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = "Bezig...";
      }
      if (errorEl && !options.silent) errorEl.textContent = "";
      if (!options.silent) setCodeStatus("", "Code controleren…");
      return lookupCode(clean)
        .then(function (discount) {
          if (!discount || !discount.code) throw new Error("Code niet gevonden");
          if (!hasCode(discount.code)) stacked.push(discount);
          if (window.ufTrack) window.ufTrack("offerte_discount_add", { code: discount.code || "" });
          if (extraInput) extraInput.value = "";
          renderStack();
          setCodeStatus("ok", "Geldig · " + (discount.summary || discount.code));
          return true;
        })
        .catch(function (err) {
          var msg = err && err.message ? err.message : "Code niet gevonden.";
          setCodeStatus("bad", msg);
          if (!options.silent && errorEl) errorEl.textContent = msg;
          return false;
        })
        .then(function (ok) {
          looking = false;
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = "Valideren";
          }
          return ok;
        });
    }

    function ensureDefaultPromo() {
      keepGeneralPromo();
      var selected = selectedPromo();
      if (!selected || looking) return;
      lookupCode(selected)
        .then(function (discount) {
          if (!discount || !discount.code) return;
          stacked = stacked.filter(function (item) {
            return item.code.toLowerCase() !== discount.code.toLowerCase() && !item.general;
          });
          stacked.unshift(discount);
          renderStack();
        })
        .catch(function () {
          keepGeneralPromo();
        });
    }

    function readCalculatorSqm() {
      var scope = root.closest(".uf-lf-product") || document;
      var inputs = scope.querySelectorAll("[data-uf-lf-sqm]");
      for (var i = 0; i < inputs.length; i++) {
        var raw = String(inputs[i].value || "").replace(/\s/g, "").replace(",", ".");
        var value = num(raw, 0);
        if (value > 0) return String(value).replace(".", ",");
      }
      return "";
    }

    function open() {
      var area = qs(modal, "[name='areaM2']");
      var fromCalc = readCalculatorSqm();
      if (area && fromCalc) area.value = fromCalc;
      result = null;
      stacked = [];
      renderStack();
      if (extraInput) extraInput.value = "";
      setCodeStatus("", "");
      setStep(0);
      if (modal.parentNode !== document.body) document.body.appendChild(modal);
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("uf-offerte-open");
      if (window.ufTrack) window.ufTrack("offerte_open", { handle: root.getAttribute("data-handle") || "" });
    }

    function close() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("uf-offerte-open");
    }

    function selectedWaste() {
      var custom = qs(modal, "[name='wasteCustom']");
      var active = qs(modal, "[data-waste].is-active");
      if (custom && custom.value) return num(custom.value, 0);
      if (active) return num(active.getAttribute("data-waste"), 10);
      return num(root.getAttribute("data-waste-diy"), 10);
    }

    function payload() {
      var variantInput = document.querySelector("input[name='id']");
      return {
        handle: root.getAttribute("data-handle") || "",
        variantId: variantInput ? variantInput.value : root.getAttribute("data-variant-id"),
        areaM2: num(qs(modal, "[name='areaM2']").value, 0),
        wastePct: selectedWaste(),
        discountCode: selectedPromo(),
        discountCodes: stacked.map(function (item) {
          return item.code;
        }),
        customerName: qs(modal, "[name='customerName']").value.trim(),
        customerEmail: qs(modal, "[name='customerEmail']").value.trim(),
        customerPhone: qs(modal, "[name='customerPhone']").value.trim(),
        customerAddress: qs(modal, "[name='customerAddress']").value.trim(),
        customerZip: qs(modal, "[name='customerZip']").value.trim(),
        customerCity: qs(modal, "[name='customerCity']").value.trim(),
      };
    }

    function clearInvalid(el) {
      if (el) {
        el.classList.remove("is-invalid");
        return;
      }
      modal.querySelectorAll("input.is-invalid, textarea.is-invalid").forEach(function (input) {
        input.classList.remove("is-invalid");
      });
    }

    function markInvalid(sel) {
      var el = qs(modal, sel);
      if (el) el.classList.add("is-invalid");
    }

    function validate() {
      clearInvalid();
      var data = payload();
      if (step === 0 && data.areaM2 <= 0) {
        markInvalid("[name='areaM2']");
        return "Vul je oppervlakte in m² in.";
      }
      if (step === 3) {
        var nameOk = data.customerName.length >= 2;
        var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.customerEmail);
        if (!nameOk) markInvalid("[name='customerName']");
        if (!emailOk) markInvalid("[name='customerEmail']");
        if (!nameOk && !emailOk) return "Vul je naam en een geldig e-mailadres in.";
        if (!nameOk) return "Vul je naam in.";
        if (!emailOk) return "Vul een geldig e-mailadres in.";
      }
      return "";
    }

    function submit() {
      var data = payload();
      var api = apiBase();
      if (!api) {
        if (errorEl) errorEl.textContent = "Offerte-API ontbreekt.";
        return;
      }
      busy = true;
      if (nextBtn) {
        nextBtn.disabled = true;
        nextBtn.textContent = "Bezig...";
      }
      ufFetch(api + "/api/offertes", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var body = {};
            if (text) {
              try {
                body = JSON.parse(text);
              } catch (err) {
                throw new Error(
                  res.ok
                    ? "Ongeldig antwoord van de server."
                    : "Offerte-server is niet bereikbaar."
                );
              }
            }
            if (!res.ok) throw new Error(body.error || "Offerte maken mislukt");
            return body;
          });
        })
        .then(function (body) {
          result = body;
          if (window.ufTrack) {
            window.ufTrack("offerte_submit", {
              number: body.number || "",
              packQty: body.packQty || 0,
              total: body.total || 0,
              handle: data.handle || ""
            });
          }
          var names = body.discountNames || data.discountCodes.join(" + ");
          var extra = "";
          if (body.checkoutCodeCreated && body.checkoutCode) {
            extra = " Winkelwagen-code <strong>" + escapeHtml(body.checkoutCode) + "</strong>.";
          }
          if (summaryEl) {
            summaryEl.innerHTML =
              "Offerte <strong>" +
              (body.number || "") +
              "</strong> is naar " +
              escapeHtml(data.customerEmail) +
              " gestuurd. " +
              (body.packQty || 0) +
              " pakken · " +
              euro(body.total || 0) +
              " incl. BTW." +
              (names ? " Kortingen: <strong>" + escapeHtml(names) + "</strong>." : "") +
              extra +
              (body.overviewUrl
                ? ' <a href="' +
                  escapeHtml(body.overviewUrl) +
                  '" target="_blank" rel="noopener">Open je offerte-menu</a>.'
                : "");
          }
          if (printLink) {
            printLink.href = body.overviewUrl || body.printUrl || "#";
            if (body.overviewUrl) printLink.textContent = "Naar offerte-menu";
          }
          if (cartLink) cartLink.href = body.cartUrl || "#";
          setStep(4);
        })
        .catch(function (err) {
          var msg = err && err.message ? err.message : "Er ging iets mis.";
          var down =
            (window.UF_OFFLINE &&
              typeof window.UF_OFFLINE.isDown === "function" &&
              window.UF_OFFLINE.isDown(err)) ||
            /failed to fetch|networkerror|load failed|niet bereikbaar/i.test(msg);
          if (down) {
            var shopify =
              window.UF_OFFLINE && typeof window.UF_OFFLINE.postContact === "function"
                ? window.UF_OFFLINE.postContact({
                    email: data.customerEmail,
                    name: data.customerName,
                    phone: data.customerPhone,
                    tags: "offerte-aanvraag",
                    body: [
                      "Offerte-aanvraag (Shopify-fallback)",
                      offerteMailBody(data),
                      "",
                      "UF_OFFERTE_V1",
                      JSON.stringify({
                        customer: {
                          customerName: data.customerName,
                          customerEmail: data.customerEmail,
                          customerPhone: data.customerPhone,
                          customerAddress: data.customerAddress,
                          customerZip: data.customerZip,
                          customerCity: data.customerCity,
                        },
                        products: [
                          {
                            handle: data.handle,
                            variantId: data.variantId,
                            areaM2: data.areaM2,
                            wastePct: data.wastePct,
                            discountCodes: data.discountCodes,
                            discountCode: data.discountCode,
                          },
                        ],
                      }),
                    ].join("\n"),
                  })
                : Promise.reject(new Error("Shopify contact ontbreekt"));
            return shopify
              .then(function () {
                if (summaryEl) {
                  summaryEl.innerHTML =
                    "Je offerte-aanvraag is ontvangen via Shopify. We sturen de offerte naar " +
                    escapeHtml(data.customerEmail) +
                    " zodra we die kunnen afronden. " +
                    contactLine();
                }
                if (printLink) printLink.href = "/pages/contact";
                if (cartLink) cartLink.href = "/cart";
                setStep(4);
              })
              .catch(function () {
                msg =
                  "Offerte-server is even offline. " +
                  contactLine() +
                  " We openen een mail met je gegevens.";
                if (window.UF_OFFLINE && typeof window.UF_OFFLINE.openMail === "function") {
                  window.UF_OFFLINE.openMail(
                    "Offerte " + (data.handle || ""),
                    offerteMailBody(data)
                  );
                }
                if (errorEl) errorEl.textContent = msg;
              });
          }
          if (errorEl) errorEl.textContent = msg;
        })
        .then(function () {
          busy = false;
          if (nextBtn) {
            nextBtn.disabled = false;
            if (step === 3) nextBtn.textContent = "Offerte maken";
          }
        });
    }

    function goNext() {
      if (busy || looking) return;
      if (step === 2 && extraInput && extraInput.value.trim()) {
        addCode(extraInput.value).then(function (ok) {
          if (ok) setStep(step + 1);
        });
        return;
      }
      var msg = validate();
      if (msg) {
        if (errorEl) errorEl.textContent = msg;
        return;
      }
      if (step === 3) {
        submit();
        return;
      }
      setStep(step + 1);
    }

    modal.addEventListener("input", function (e) {
      if (e.target && e.target.classList) clearInvalid(e.target);
    });

    openBtns.forEach(function (openBtn) {
      openBtn.addEventListener("click", function (e) {
        e.preventDefault();
        open();
      });
    });
    modal.querySelectorAll("[data-uf-offerte-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    if (backBtn) {
      backBtn.addEventListener("click", function () {
        if (!busy) setStep(step - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        goNext();
      });
    }
    if (addBtn) {
      addBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (extraInput) addCode(extraInput.value);
      });
    }
    if (cartLink) {
      cartLink.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!result || cartLink.getAttribute("data-uf-offerte-busy") === "1") return;
        cartLink.setAttribute("data-uf-offerte-busy", "1");
        var label = cartLink.textContent;
        cartLink.textContent = "Bezig…";
        applyOfferteCart({
          variantId: result.variantId || root.getAttribute("data-variant-id"),
          packQty: result.packQty,
          discount: result.checkoutCode || "",
          fallbackUrl: result.cartUrl || cartLink.getAttribute("href") || "",
        }).then(function () {
          cartLink.removeAttribute("data-uf-offerte-busy");
          cartLink.textContent = label;
        });
      });
    }
    if (stackEl) {
      stackEl.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-remove-code]");
        if (!btn) return;
        removeCode(btn.getAttribute("data-remove-code"));
      });
    }
    modal.querySelectorAll("[data-waste]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        modal.querySelectorAll("[data-waste]").forEach(function (el) {
          el.classList.toggle("is-active", el === btn);
        });
        var custom = qs(modal, "[name='wasteCustom']");
        if (custom) custom.value = "";
      });
    });
    modal.querySelectorAll("[data-promo]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        modal.querySelectorAll("[data-promo]").forEach(function (el) {
          el.classList.toggle("is-active", el === btn);
        });
        var promo = (btn.getAttribute("data-promo") || "").trim();
        var current = defaultPromo();
        if (!promo) {
          if (current) removeCode(current);
          stacked = stacked.filter(function (item) {
            return !item.general;
          });
          renderStack();
          return;
        }
        keepGeneralPromo();
        addCode(promo, { silent: true });
      });
    });
    document.addEventListener("keydown", function (e) {
      if (!modal.classList.contains("is-open")) return;
      if (e.key === "Escape") close();
      if (e.key === "Enter") {
        e.preventDefault();
        if (document.activeElement === extraInput) {
          addCode(extraInput.value);
          return;
        }
        if (nextBtn && !nextBtn.hidden && !busy) nextBtn.click();
      }
    });
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function escapeAttr(s) {
    return escapeHtml(s).replace(/'/g, "&#39;");
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-uf-offerte]").forEach(init);
  });
})();
